import { useSuspenseQuery } from "@apollo/client/react";

import {
  GetRelationTypesDocument,
  type GetRelationTypesQuery,
  type GetRelationTypesQueryVariables,
} from "~/features/admin/relationTypes/gqls";
import { useTenant } from "~/features/tenant/context";

/**
 * Loads the full relation-type list for the current tenant (orderBy name ASC).
 * V1 fetched everything at once and filtered / paginated client-side, so this
 * uses the same tenant-scoped query and the list view paginates in the browser.
 */
export function useRelationTypeList() {
  const { tenantId } = useTenant();
  if (!tenantId) {
    throw new Error("Tenant ID is required");
  }

  return useSuspenseQuery<GetRelationTypesQuery, GetRelationTypesQueryVariables>(GetRelationTypesDocument, {
    variables: { tenantId },
    fetchPolicy: "cache-and-network",
  });
}
